import axios from "axios";
import { getToken, setToken } from "./session";
import Config from "@/config";
axios.defaults.baseURL = '/api'
class HttpRequest {
  constructor(baseUrl) {
    this.baseUrl = baseUrl || Config.api[process.env.NODE_ENV];
    this.queue = {}; // 队列
  }
  /**
   * 获取axios基础配置
   */
  config() {
    const config = {
      baseURL: this.baseUrl,
      method: "GET",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
      withCredentials: true,
      timeout: 15000
    };
    if (getToken()) {
      config.headers["token"] = getToken();
    }
    return config;
  }
  /**
   * 销毁队列中的url
   * @param {*} url
   */
  destroy(url) {
    delete this.queue[url];
  }
  /**
   * 拦截器
   * @param {*} instance
   * @param {*} url
   */
  interceptors(instance, url) {
    // 请求拦截 拦截发送数据
    instance.interceptors.request.use(
      config => {
        // 添加全局的loading...
        this.queue[url] = true; // 加入队列
        return config;
      },
      error => {
        return Promise.reject(error);
      }
    );
    // 响应拦截 一般用于处理登录
    instance.interceptors.response.use(
      response => {
        if (response.headers.token !== undefined) {
          setToken(response.headers.token);
        }
        this.destroy(url);
        const {
          data: { data },
          status
        } = response;
        return { data, status, response };
      },
      error => {
        this.destroy(url);
        let _response = error.response;
        let errorInfo;
        if (!_response) {
          errorInfo = {
            status: -1,
            code: 50000,
            data: undefined,
            msg: "系统异常"
          };
        } else {
          // 重新组装
          errorInfo = {
            status: _response.status,
            config: _response.config,
            ..._response.data
          };
        }
        return Promise.reject(errorInfo);
      }
    );
  }
  /**
   * 请求管理
   * @param {*} options 配置信息
   */
  request(options) {
    const instance = axios.create();
    options = Object.assign({}, this.config(), options);
    this.interceptors(instance, options.url);
    return instance(options);
  }
}

export default new HttpRequest();



// WEBPACK FOOTER //
// ./src/libs/axios.js